<template>
    <v-layout row wrap v-redirect-if-no-permission:INTERVIEW_MANAGEMENT>
        <loading-component :value="loading"/>
        <v-dialog :value="!!activeEvent" @input="activeEvent = null" max-width="50%">
            <v-card>
                <v-card-text class="title ">
                    {{ $t("acquisitionPage.deleteShiftConfirm") }}
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="activeEvent = null">{{ $t("acquisitionPage.cancel") }}</v-btn>
                    <v-btn color="red" @click="deleteEvent">{{ $t("acquisitionPage.delete") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="sliceInfoDialog" max-width="50%">
            <v-card class="pa-6">
                <v-card-title class="title font-weight-bold">
                    {{ $t("acquisitionPage.updateSliceTitle") }}
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-text-field type="number" min="1" v-model="slice" :label='$t("acquisitionPage.interviewInterval")'/>
                    <v-btn @click="saveSlice">
                        {{ $t("acquisitionPage.save") }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="maxCaptainsDialog" max-width="50%">
            <v-card class="pa-6">
                <v-card-title class="title font-weight-bold">
                    {{ $t("acquisitionPage.updateMaxCaptainsTitle") }}
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-text-field type="number" min="1" v-model="maxCaptainsPerInterview"
                                  :label='$t("acquisitionPage.maxCaptainsLabel")'/>
                    <v-btn @click="saveMaxCaptainsPerInterview">
                        {{ $t("acquisitionPage.save") }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-flex sm12>
            <full-calendar
                    ref="calendar"
                    default-view="timeGridWeek"
                    :events="events"
                    :event-overlap="false"
                    :droppable="false"
                    :editable="true"
                    :selectable="true"
                    :all-day-slot="false"
                    slot-duration="00:15:00"
                    event-order="start"
                    @eventRender="eventRender"
                    :plugins="calendarPlugins"
                    @select="select"
                    @eventDrop="eventDrop"
                    @eventClick="({event}) => activeEvent = event"
                    @eventResize="eventResize"/>
        </v-flex>
        <v-btn @click="sliceInfoDialog = true" style="z-index:3;" color="primary" round fixed bottom right>
            {{ $t("acquisitionPage.updateSliceTitle") }}
        </v-btn>
        <v-btn @click="maxCaptainsDialog = true" style="z-index:3;margin-inline-end: 180px;" color="primary" round fixed
               bottom right>
            {{ $t("acquisitionPage.updateMaxCaptainsTitle") }}
        </v-btn>
    </v-layout>
</template>

<script>
    import FullCalendar from "@fullcalendar/vue";
    import LoadingComponent from "@/components/LoadingComponent";
    import FullCalendarTimeGrid from "@fullcalendar/timegrid";
    import FullCalendarInteraction from "@fullcalendar/interaction";

    export default {
        name: "AvailableInterviewTimes",
        title() {
            return this.$t("acquisitionPage.pageTitleAvailableInterviews");
        },
        components: {LoadingComponent, FullCalendar},
        data() {
            return {
                date: null,
                loading: false,
                events: [],
                activeBooking: null,
                activeEvent: null,
                sliceInfoDialog: false,
                maxCaptainsDialog: false,
                slice: null,
                maxCaptainsPerInterview: null
            }
        },
        computed: {
            calendarPlugins() {
                return [FullCalendarTimeGrid, FullCalendarInteraction];
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.AVAILABLE_INTERVIEW_TIMES)
                .then(
                    ({data: {data}}) => {
                        for (let event of data)
                            this.addEvent(event);
                    }
                )
                .finally(
                    () => this.loading = false
                )
        },
        watch: {
            maxCaptainsDialog(val) {
                if (val === true) {
                    this.loading = true;
                    this.axios.get(this.api.ACTIONS.INTERVIEW_MAX_CAPTAINS).then(
                        ({data: {data: {MAX_CAPTAINS_PER_INTERVIEW}}}) => {
                            this.maxCaptainsPerInterview = MAX_CAPTAINS_PER_INTERVIEW;
                        }
                    ).finally(
                        () => this.loading = false
                    )
                }
            },
            sliceInfoDialog(val) {
                if (val === true) {
                    this.loading = true;
                    this.axios.get(this.api.ACTIONS.INTERVIEW_SLICE).then(
                        ({data: {data: {INTERVIEW_SLICE: slice}}}) => {
                            this.slice = slice;
                        }
                    ).finally(
                        () => this.loading = false
                    )
                }
            }
        },
        methods: {
            saveMaxCaptainsPerInterview() {
                this.loading = true;
                this.maxCaptainsDialog = false;
                this.axios.put(this.api.ACTIONS.INTERVIEW_MAX_CAPTAINS, {
                    'value': this.maxCaptainsPerInterview
                })
                    .then(
                        () => window.getApp.$emit('SHOW_TOAST', this.$t('acquisitionPage.toastSaved'), 'green')
                    )
                    .catch(
                        ({response: {data}}) => window.getApp.$emit('SHOW_TOAST', this.$t('acquisitionPage.toastErrorLog'), 'red')
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            saveSlice() {
                this.loading = true;
                this.sliceInfoDialog = false;
                this.axios.put(this.api.ACTIONS.INTERVIEW_SLICE, {
                    'value': this.slice
                })
                    .then(
                        () => window.getApp.$emit('SHOW_TOAST', this.$t('acquisitionPage.toastSaved'), 'green')
                    )
                    .catch(
                        ({response: {data}}) => window.getApp.$emit('SHOW_TOAST', this.$t('acquisitionPage.toastErrorLog'), 'red')
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            eventRender({event, el}) {
            },
            eventDrop({event, revert}) {
                if (moment(event.start).format("YYYY-MM-DD") !== moment(event.end).format("YYYY-MM-DD")) {
                    revert();
                    return;
                }
                this.loading = true;
                const from = moment(event.start).format("HH:mm");
                const to = moment(event.end).format("HH:mm");
                const weekdayId = moment(event.start).day() + 1;
                this.axios.put(this.api.ACTIONS.AVAILABLE_INTERVIEW_TIMES + '/' + event.id, {
                    from,
                    to,
                    weekday_id: weekdayId
                })
                    .catch(
                        revert
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            deleteEvent() {
                this.loading = true;
                this.axios.delete(this.api.ACTIONS.AVAILABLE_INTERVIEW_TIMES + '/' + this.activeEvent.id)
                    .then(
                        () => this.activeEvent.remove()
                    )
                    .finally(
                        () => {
                            this.activeEvent = null;
                            this.loading = false
                        }
                    )
            },
            eventResize({event, revert}) {
                if (moment(event.start).format("YYYY-MM-DD") !== moment(event.end).format("YYYY-MM-DD")) {
                    revert();
                    return;
                }
                this.loading = true;
                const from = moment(event.start).format("HH:mm");
                const to = moment(event.end).format("HH:mm");
                const weekdayId = moment(event.start).day() + 1;
                this.axios.put(this.api.ACTIONS.AVAILABLE_INTERVIEW_TIMES + '/' + event.id, {
                    from,
                    to,
                    weekday_id: weekdayId
                })
                    .catch(
                        revert
                    )
                    .finally(
                        () => this.loading = false
                    )

            },
            addEvent(data) {
                const dataEvent = {
                    id: data.id,
                    title: this.$t("acquisitionPage.available"),
                    start: moment().startOf('week').add(data.weekday_id - 1, 'days').add(data.from.split(":")[0], 'hours').add(data.from.split(":")[1], "minutes").toDate(),
                    end: moment().startOf('week').add(data.weekday_id - 1, 'days').add(data.to.split(":")[0], 'hours').add(data.to.split(":")[1], "minutes").toDate(),
                    customButtons: {
                        myCustomButton: {
                            text: 'custom!',
                            click: () => {
                                alert('clicked the custom button!');
                            }
                        }
                    }
                };
                this.events = [...this.events, dataEvent];
            },
            select(info) {
                const {startStr, endStr} = info;
                if (moment(startStr).format("YYYY-MM-DD") === moment(endStr).format("YYYY-MM-DD")) {
                    const from = moment(startStr).format("HH:mm");
                    const to = moment(endStr).format("HH:mm");
                    const weekdayId = moment(startStr).day() + 1;
                    this.loading = true;
                    this.axios.post(this.api.ACTIONS.AVAILABLE_INTERVIEW_TIMES, {from, to, weekday_id: weekdayId})
                        .then(
                            ({data: {data}}) => this.addEvent(data)
                        )
                        .finally(
                            () => this.loading = false
                        )
                } else {
                    alert(this.$t('acquisitionPage.sameDayAlert'));
                }
            }
        }
    }
</script>

<style scoped>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/timegrid/main.css';

    div >>> .fc-toolbar.fc-header-toolbar {
        display: none;
    }

    .removebtn {
        color: black;
        position: absolute;
        top: 0;
        inset-inline-end: 0;
        width: 13px;
        height: 13px;
        text-align: center;
        border-radius: 50%;
        font-size: 10px;
        cursor: pointer;
        background-color: #FFF
    }
</style>
